import { render, staticRenderFns } from "./foodrecipes.vue?vue&type=template&id=5a46a5ea"
import script from "./foodrecipes.vue?vue&type=script&lang=js"
export * from "./foodrecipes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports